import { conversations } from '@/services/history'
export default {
    namespaced: true,
    state: {
        hisDataList:[] // 历史数据
    },
    mutations: {
        setHisDataList(state,list) {
            state.hisDataList = list
        }
    },
    actions: {
        postAllHistory(context,userid) {
            conversations({ userId: userid }).then(res => {
                if(res.code == 200){
                    context.commit('setHisDataList',res.data.records)
                }
            })
        }
    }
}